export default __webpack_public_path__ + "static/media/icon-user-journey.a28d8841.svg";